module.exports = __webpack_public_path__ + "img/back.ac3c973e.svg";